import types from './types';

function meansOfDisbursementReducer(state, action) {
  switch(action.type) {
    case types.SET_MODALIDAD:
      return {...state, disbursementModality: {...state.disbursementModality, modalidad: action.modalidad}}
    case types.SET_SIMULATION:
      return {...state, simulation: action.simulation}
    case types.SET_FINANCIAL_ENTITIE:
      return {...state, disbursementModality: {...state.disbursementModality, financialEntitie: action.financialEntitie }}
    case types.SET_SELECTED_STATE:
      return {...state, disbursementModality: {...state.disbursementModality, state: action.state }}
    case types.SET_SELECTED_CITY:
      return {...state, disbursementModality: {...state.disbursementModality, city: action.city }}
    case types.SET_ACCOUNT_TYPE:
        return {...state, disbursementModality: {...state.disbursementModality, accountType: action.accountType}}
    case types.SET_DISBURSEMENT_MODALITY_DATA:
        return {...state, disbursementModality: {...state.disbursementModality, numeroCuenta: action.data.numeroCuenta}}
    case types.SET_MEANS_OF_DISBURSEMENT:
        return {...state, disbursementModality: {...state.disbursementModality, meansOfDisbursement: action.meansOfDisbursement}}
    case types.SET_CLIENT_TYPE:
        return {...state, suggestedCustomerSegmentAndType: {...state.suggestedCustomerSegmentAndType, clientType: action.clientType}}
    case types.SET_CREDIT:
      return {...state, credit: action.credit }
    case types.SET_SOLICITATION:
      return {...state, solicitation: action.solicitation }
    default:
      return state;
  }
}

export default meansOfDisbursementReducer;
